<rcl-header id="checkin-rcl-header" class="no-print" [bg]="brandName" [expandable]="false">
  <!-- inline-svg does not work with string interpolation in the src path -->
  <a id="checkin-rcl-header__link" href="" aria-haspopup="true" (click)="goToBrandUrl($event)">
    <img
      id="checkin-rcl-header__link__header-logo"
      title="home"
      class="{{ brandName }}-header-logo"
      src="assets/icons/{{ brandName }}-logo.svg"
      alt="{{ brandCorpAltText }} Home"
      />
  </a>

  @if (isProgressBarEnabled) {
    <rcl-progress-bar [ngClass]="{ 'apply-nav-margin': shouldDisplayMessageCenter && screensize().isdesktop }" id="checkin-rcl-header__progress-bar">
      <rcl-progress-bar-item
        id="checkin-rcl-header__progress-bar__item-details"
        [disabled]="false"
        [active]="isActiveLink(constants.ROUTES.GUEST_DETAILS)"
        >
        <a id="checkin-rcl-header__progress-bar__item-details__link" [routerLink]="constants.ROUTES.GUEST_DETAILS">
          {{ bundle() && bundle()['progress.bar.guest'] }}
        </a>
      </rcl-progress-bar-item>
      <rcl-progress-bar-item
        id="checkin-rcl-header__progress-bar__item-oexpenses"
        [disabled]="!isGuestDetailsCompleted() || !isTravelQuestionnaireCompleted()"
        #oeItem
        [active]="isActiveLink(constants.ROUTES.ONBOARD_EXPENSE)"
        >
        @if (!oeItem.disabled) {
          <a
            id="checkin-rcl-header__progress-bar__item-oexpenses__link"
            [routerLink]="constants.ROUTES.ONBOARD_EXPENSE"
            >
            {{ bundle() && bundle()['progress.bar.onboard.expenses'] }}
          </a>
        }
        @if (oeItem.disabled) {
          <a id="checkin-rcl-header__progress-bar__item-oexpenses__link-disabled">
            {{ bundle() && bundle()['progress.bar.onboard.expenses'] }}
          </a>
        }
      </rcl-progress-bar-item>
      <rcl-progress-bar-item
        id="checkin-rcl-header__progress-bar__item-cruise-details"
        [disabled]="!isOnboardExpensesCompleted() || !isTravelQuestionnaireCompleted()"
        #contractsItem
        [active]="isActiveLink(constants.ROUTES.CRUISE_DETAILS)"
        >
        @if (!contractsItem.disabled) {
          <a
            id="checkin-rcl-header__progress-bar__item-cruise-details__link"
            [routerLink]="constants.ROUTES.CRUISE_DETAILS"
            >
            {{ bundle() && bundle()['progress.bar.contracts'] }}
          </a>
        }
        @if (contractsItem.disabled) {
          <a id="checkin-rcl-header__progress-bar__item-cruise-details__link-disabled">
            {{ bundle() && bundle()['progress.bar.contracts'] }}
          </a>
        }
      </rcl-progress-bar-item>
      @if (smartship && arrivalTimeEnabled) {
        <rcl-progress-bar-item
          id="checkin-rcl-header__progress-bar__item-arrival"
          [disabled]="!isCruiseDetailsCompleted() || !isTravelQuestionnaireCompleted()"
          #arrivalInfoItem
          [active]="isActiveLink(constants.ROUTES.ARRIVAL_INFO)"
          >
          @if (!arrivalInfoItem.disabled) {
            <a
              id="checkin-rcl-header__progress-bar__item-arrival__link"
              [routerLink]="constants.ROUTES.ARRIVAL_INFO"
              >
              {{ bundle() && bundle()['progress.bar.arrival'] }}
            </a>
          }
          @if (arrivalInfoItem.disabled) {
            <a id="checkin-rcl-header__progress-bar__item-arrival__link-disabled">
              {{ bundle() && bundle()['progress.bar.arrival'] }}
            </a>
          }
        </rcl-progress-bar-item>
      }
    </rcl-progress-bar>
  }
  @if (shouldDisplayMessageCenter && screensize().isdesktop) {
    <rcl-header-extra-option>
      <main-nav-message-center [messageCenterIcon]="true"></main-nav-message-center>
    </rcl-header-extra-option>
  }
  <rcl-menu-button
    id="checkin-rcl-header__menu-button"
    [text]="bundle() ? bundle()['user.menu.label.my.account'] : ''"
    [expanded]="showMenu"
    (onToggleNav)="toggleShowMenu()"
    >
  </rcl-menu-button>

  @if (!isSafari) {
    <rcl-menu-button-dropdown id="checkin-rcl-header__menu-button-dropdown">
      <app-user-menu [(showMenu)]="showMenu" [bundle]="bundle()" (displayBadgeOnProfileMenu)="displayBadgeOnProfile($event)" [displayMessageCenter]="screensize().isphone && shouldDisplayMessageCenter" [hideMessageCenterContainer]="hideMessageCenterContainer"></app-user-menu>
    </rcl-menu-button-dropdown>
  }
</rcl-header>

@if (isSafari) {
  <app-user-menu id="checkin-user-menu" [(showMenu)]="showMenu" [bundle]="bundle()" (displayBadgeOnProfileMenu)="displayBadgeOnProfile($event)" [displayMessageCenter]="screensize().isphone && shouldDisplayMessageCenter" [hideMessageCenterContainer]="hideMessageCenterContainer"></app-user-menu>
}
@if (shouldDisplayMessageCenter) {
<main-nav-message-center-box></main-nav-message-center-box>
}
<router-outlet></router-outlet>
